export default "__VITE_ASSET__C_B93qB$__"